import CreateEditAttribute from "../../../Components/Pricings/Attributes/CreateEditAttribute";

export default function CreateAttribute() {
    return (
        <CreateEditAttribute/>
    )
}